import CommonTablePage, { CommonTablePagePropsInterface } from '../../../../../components/common/common-table/common-table-page'
import React, { useRef, useState,useEffect } from 'react'
import  {TraceabilityColumnModel, productionOperatorLabel} from '../work-order-management-page/work-order-management-column-model'
import { urlKey } from '../../../../../services/api/api-urls'
import CommonDialog from '../../../../../components/common/others/common-dialog'
import { ApiRequest } from '../../../../../services/api/api'
import SweetAlertService from '../../../../../services/lib/utils/sweet-alert-service'
import { getRandomKey } from '../../../../../services/lib/utils/helpers'
import { Button } from 'antd'
import { useDocumentTitle } from '../../../../../services/title/useDocumentTitle'
import { mapTrackingRows } from './tracking-render-data'
import moment from 'moment'

interface WorkOrderData {
  serialNumber: string;
  productCode: string;
  productName: string;
  status: string;
  quantityOrder: number;
  quantityInStock: number;
  quantityMade: number;
  quantityDispatched: number;
  quantityHold: number;
  createdAt: string;
  madedAt: string;
  packingSlipNos: string[];
}

interface BoxInfo {
  barCode: string;
  quantity: number;
  status: string;
}

const refreshTime=5;
const WorkOrderTrackingPage = (props: {stockMonitorProductId?: any}) => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false)
  const [isShowSpinner, setIsShowSpinner] = useState(true)
  const [open, setOpen] = useState(false)
  // exportData 只在点击 Export to CSV 时被读取，从不参与页面渲染，
  // 因此用 ref 保存而不是 state：更新 ref 不会触发页面 re-render。
  // 若用 useState，onFilterChange/onSearchChange 回调里的 setState 会导致
  // 页面重新渲染，CommonTable 传给 material-table 的内联 options（含
  // rowStyle 等新函数引用）会被判定为 props 变化，material-table 随即
  // 重置排序/筛选/分页。ref 方案下 debounce 也不再需要：material-table
  // 自身已按 debounceInterval 去抖后才回调，这里直接同步赋值即可。
  const exportDataRef = useRef<any[]>([])

  const tableRef = useRef<any>(null)

  useEffect(() => {
    return () => { };
  });
  useDocumentTitle();

   useEffect(() => {
    // document.title = "Product Traceability";
  }, []);

  const actionButtons: any = [
  ]

  const getRenderData = async (data: any) => {
    let res = await ApiRequest({
      url: 'Product/GetAllProductName',
      method: 'get'
    })
    const renderData = mapTrackingRows(data, res.data.data, props.stockMonitorProductId)
    exportDataRef.current = renderData
    return renderData
  }

  const exportToCSV = () => {


    const dataToExport = exportDataRef.current;
    
    if (dataToExport.length === 0) {
      SweetAlertService.errorMessage('No data to export');
      return;
    }

    const headers = [
      'Work Order No.',
      'Product Code',
      'Product Name',
      'Status',
      'Order Qty',
      'QTY InStock',
      'QTY Manufactured',
      'QTY Dispatched',
      'QTY Hold',
      'Created At',
      'Manufacture Date',
      'Production Operator',
    ];

    // CSV 字段转义函数：如果字段包含逗号、换行或双引号，用双引号包围并转义内部双引号
    const escapeCSVField = (field: any) => {
      const str = String(field || '');
      if (str.includes(',') || str.includes('\n') || str.includes('"')) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    };

    const csvContent = [
      headers.join(','),
      ...dataToExport.map(row => {
        // 使用原始日期字段或格式化后的字符串
        const formatDate = (dateVal: any) => {
          if (!dateVal) return '';
          // 如果已经是格式化后的字符串（包含逗号等），只取日期部分
          if (typeof dateVal === 'string' && dateVal.includes(',')) {
            return dateVal.split(',')[0]; // 只返回日期部分
          }
          // 否则尝试转换为日期格式
          // 后端原始字符串是 UTC（无 Z 后缀），必须按 UTC 解析再转本地；
          // 否则 new Date 会当本地时间解析，NZ 时区下日期会差一天
          const date = moment.utc(String(dateVal));
          return date.isValid() ? date.local().format('DD/MM/YYYY') : '';
        };

        return [
          escapeCSVField(row.serialNumber || ''),
          escapeCSVField(row.productCode || ''),
          escapeCSVField(row.productName || ''),
          escapeCSVField(row.status || ''),
          escapeCSVField(row.quantityOrder || '0'),
          escapeCSVField(row.quantityInStock || '0'),
          escapeCSVField(row.quantityMade || '0'),
          escapeCSVField(row.quantityDispatched || '0'),
          escapeCSVField(row.quantityHold || '0'),
          escapeCSVField(formatDate(row.createdAt)),
          escapeCSVField(formatDate(row.madedAt)),
          escapeCSVField(productionOperatorLabel(row.productionOperator)),
        ].join(',');
      })
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `work_order_tracking_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getUpdateData = (dataDetail: any) => {
    if ([10, 0].includes(dataDetail.workOrderStatusId)) {
      SweetAlertService.errorMessage('This order is cancelled or completed, so not deletable.')
      return ''
    }
    return dataDetail
  }
  const updateRMNote = async (rowData: any) => {
    const result = await SweetAlertService.inputConfirm({type: 'text', title: 'Update Notes', placeholder: 'Notes'})
    if (result !== null) {
      if (!result) {
        await SweetAlertService.errorMessage('Please type in Notes before submitting')
        return
      } else {
        ApiRequest({
          url: 'WorkOrder/UpdateRawMaterialNote?id=' + rowData.workOrderId + '&notes=' + result,
          method: 'put'
        }).then(_ => {
          setTriggerResetData(getRandomKey())
        })
      }
    }
  }

  const handleFilteredDataChange = (data: any) => { 
    if (!data?.current?.dataManager?.filteredData) return;
    exportDataRef.current = data.current.dataManager.filteredData;
  };

  const handleSearchedDataChange = (data: any) => { 
    if (!data?.current?.dataManager?.searchedData) return;
    exportDataRef.current = data.current.dataManager.searchedData;
  };
  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.WorkOrder,
    getAllUrl: `/WorkOrder/GetTrackingInfo`,
    title: 'Product Traceability',
    column: TraceabilityColumnModel({updateRMNote: updateRMNote}),
    mappingRenderData: (data: any) => getRenderData(data),
    mappingUpdateData: (dataDetail: any) => getUpdateData(dataDetail),
    triggerResetData: triggerResetData,
    actionButtons: props.stockMonitorProductId ? [] : actionButtons,
    isNotDeletable: true,
    isNotEditable: true,
    isNotAddable: true,
    isShowSpinnerOnInit: isShowSpinner,
    onFilterChange: handleFilteredDataChange,
    onSearchChange: handleSearchedDataChange
  }

  return (
    // <div style={{ whiteSpace: 'pre-line' }}>
    <div style={{ whiteSpace: 'pre-line' }}>
      <div style={{ marginBottom: '16px', textAlign: 'right' }}>
        <Button type="primary" onClick={exportToCSV}>Export to CSV</Button>
      </div>
      <CommonTablePage {...commonTablePageProps} />
    </div>
  )
}

export default WorkOrderTrackingPage
